import { Component, Inject, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChange } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CONST_AWS_API, API } from 'src/app/core/constants';
import { API as AWS_API, input } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { url } from 'inspector';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-playlist',
  templateUrl: './add-playlist.component.html',
  styleUrls: ['./add-playlist.component.scss']
})
export class AddPlaylistComponent implements OnInit {
  playListForm: FormGroup;
  userInfo: any = {};
  userInfoSubscription: Subscription;
  userData: any;
  screenType: string = 'Add'
  @Input() playlistPatchData: any = null
  @Input() organizationId: any = null
  @Output() newItemEvent = new EventEmitter<any>();
  settingsData:any;

  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    private ngxLoader: NgxUiLoaderService,
    private commonSubscribeService: CommanSubscribeService,
    public dialogRef: MatDialogRef<AddPlaylistComponent>,
    public toaster: ToastrService,
    @Inject(MAT_DIALOG_DATA) private _data: any
  ) {
    if (_data && _data.details) {
      this.userData = _data.details;
    }
  }

  ngOnInit() {
    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.buildForm(this.playlistPatchData);
    this.settingsData = this._data?.details?.settingsData;
    this.addStyle();
  }

  buildForm(data?) {
    this.screenType = data ? 'Edit' : 'Add';
    this.playListForm = this.formBuilder.group({
      playlist_name: [data ? data.playlist_name : null, Validators.required],
      playlist_type: [data ? data.playlist_type : "audio", Validators.required],
    });
  }

  get getplayListForm() {
    return this.playListForm.getRawValue();
  }

  savePlayList() {
    let payload = {}
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Creating playlist for album ${albumId} - ${userId}`);
    const data = {
        actionType: "network",
        metaData: {
          title: `Creating playlist for album ${albumId}`,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.commonSubscribeService.slugInfo?.organization_id || null,
        clickAction:'playlist'
    }
    this.commonSubscribeService.sendTriggeredEvent(data);

    if (this.router.url.includes('my-library')) {
      this.playListForm.get('playlist_type').setValidators(Validators.required);
    } else {
      this.playListForm.get('playlist_type').clearValidators();
    }
    this.playListForm.get('playlist_type').updateValueAndValidity();

    if (this.playListForm.valid) {
      if (this.router.url.includes('my-library')) {
        if (this.screenType == 'Add') {
          payload = {
            "user_id": this.userInfo.id,
            "playlist_type": this.getplayListForm.playlist_type,
            "playlist_name": this.getplayListForm.playlist_name,
            "organization_id": this.organizationId || this.userData?.organization_id || null
          }
        } else {
          payload = {
            "id": this.playlistPatchData.id,
            "playlist_name": this.getplayListForm.playlist_name,
            "user_id": this.userInfo.id,
            "organization_id": this.organizationId || this.userData?.organization_id || null
          }
        }
      } else {
        payload = {
          "user_id": this.userInfo.id,
          "performer_id": this.userData.performerId,
          "playlist_type": this.userData.playlist_type ? this.userData.playlist_type : this.getplayListForm.playlist_type,
          "playlist_name": this.getplayListForm.playlist_name,
          "organization_id": this.organizationId || this.userData?.organization_id || null
        }
      }
      let data = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          "Authorization": `Bearer ${this.userInfo.access_token}`
        },
        response: true,
        body: {
          ...payload
        }
      }
      this.ngxLoader.start();
      AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.SAVE_USER_PLAYLIST, data).then(response => {
        this.ngxLoader.stop();
        if (response.data.statusCode === '200') {
          this.sendOutputValue('success')
          if (this.screenType == 'Edit') {
            this.toaster.success("Playlist updated successfully")
          } else {
            this.toaster.success("Playlist created successfully")
          }
        } else {
          this.toaster.error(response.data.message)
        }
      }).catch(error => {
        this.ngxLoader.stop();
      });
    }
  }

  close(type): void {
    this.dialogRef.close(type);
  }

  sendOutputValue(value) {
    this.newItemEvent.emit(value);
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Created playlist cancelled for album ${albumId} - ${userId}`);
    const data = {
        actionType: "network",
        metaData: {
          title: `Created playlist cancelled for album ${albumId}`,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.commonSubscribeService.slugInfo?.organization_id || null,
        clickAction:'playlist'
    }
    this.commonSubscribeService.sendTriggeredEvent(data);

    if (this.dialogRef && Object.keys(this.dialogRef).length > 0) {
      this.close('yes');
    }
  }

  addStyle(){
    const dynamicColor = this.settingsData?.form_font_secondary_color ;
    document.documentElement.style.setProperty('--invalid-border-color', dynamicColor);
    document.documentElement.style.setProperty('--before-border-color', dynamicColor);
     //mat-select-dropdown
     document.documentElement.style.setProperty('--select-panel-bg', this.settingsData?.bg_tertiary_color);
     document.documentElement.style.setProperty('--select-panel-text', this.settingsData?.font_tertiary_color);
     document.documentElement.style.setProperty('--select-panel-text-hover', this.settingsData?.form_font_secondary_color);
     //dropdown selected value
    document.documentElement.style.setProperty('--select-value-text', this.settingsData?.form_font_secondary_color);
  }

  ngOnChanges(changes: SimpleChange) {
    const changedValue = changes['playlistPatchData']
    this.buildForm(changedValue.currentValue)
  }

  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
  }

}
